import React from "react";
import { Auth0Provider, AppState } from "@auth0/auth0-react";
import { navigate } from "gatsby";

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || "/login", { replace: true });
  };

  return (
    <Auth0Provider
      domain={process.env.GATSBY_AUTH0_DOMAIN}
      clientId={process.env.GATSBY_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri:
          typeof window !== "undefined" ? window.location.origin + "/login/" : undefined,
        audience: process.env.GATSBY_AUTH0_AUDIENCE,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default AuthProvider;
